import { Method } from 'axios';
import { Executable } from '../executable';
import { BambuBrand, BambuBrandUIConfig } from '../interfaces/brands';

/**
 * The the brands that belong to the tenant.
 */
export class GetBrands extends Executable<BambuBrand[]> {
  public getMethod(): Method {
    return 'get';
  }

  public getResponse(apiResponse: any): BambuBrand[] {
    return apiResponse;
  }

  public getURLPath(tenantId?: string): string {
    return ``;
  }

  constructor() {
    super();
  }

  /**
   * getBody is used by the BambuClient to properly construct the request object body.
   * @returns Returns the expected body of the request utilizing the defined request attributes.
   */
  getBody(): undefined {
    return undefined;
  }

  /**
   * getRootPath is used by the BambuClient to properly construct the request call.
   * @returns The root path of the request
   */
  getRootPath(): string | undefined {
    return 'brands';
  }
}
